import { ModalMediaProps } from './types';

import styles from './modal.module.css';

export const ModalMedia = (props: ModalMediaProps) => {
  if (props.variant === 'image-or-video') {
    return (
      <div data-variant={props.variant} className={styles.mediaWrapper}>
        {props.children}
      </div>
    );
  }

  return (
    <div
      className={styles.mediaWrapper}
      data-variant={props.variant}
      style={{
        height: props.height,
        '--modal-background-color': props.bgColor,
      }}
    >
      {props.children}
    </div>
  );
};
